import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'
import { Redirect } from 'react-router-dom'
import ErrorMessage from '../Messages/errorMessage.jsx';
import SuccessMessage from '../Messages/successMessage.jsx';
import InputInitialForm from '../Forms/inputOfInitialForm.jsx';
import CommonFetch from '../../requests/commonFetch'

export default class Registration extends Component {
    constructor(props) {
        super(props)

        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            code: '',
            password: '',
            checkbox: false,
            errorMessage: '',
            successMessage: 'You have successfully registered',
            passwordNotPassRequirements: false,
        }

        this.arrayOfErrorMessage = {
            "already_exist": "Already exist",
            "email_not_valid": "Email not valid",
            "referrer_not_exist": "Referrer not exist",
            "send_mail_problem": "Send mail problem",
            "wrong_captcha": "Wrong captcha",
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];

        this.errorMessage = React.createRef();
        this.successMessage = React.createRef();
    }

    componentDidMount() {
        if(window.location.href.split('?')[1]) {
            this.setState({
                code: (((window.location.href.split('referrer_code')[1]).replace(/[^A-Z|0-9]/gi, '')).slice(0,10)).toUpperCase()
            })
            this.codeInput.removeAttribute('readonly');
            this.codeInput.classList.add('active');
        }
    }

    sendFromRegistration = event => {
        event.preventDefault();
        let form = event.target,
            formData = new FormData(form),
            inputs = form.querySelectorAll('input[type=text], input[type=password]'),
            checkbox = form.querySelector('input[type=checkbox]'),
            valid = true;

        inputs.forEach(item => {
            if (!item.value && item.getAttribute('name') !== 'code') {
                valid = false;
            }
            this.checkValidInput(item);
        })

        if (!checkbox.checked)
            valid = false;

        if (valid) {
            CommonFetch({
                path: 'ui/auth/post_register',
                method: 'POST',
                data: formData,
            }).then(data => {
                this.recaptcha.reset()

                if (data.success) {
                    this.setState({
                        passwordNotPassRequirements: false,
                    })
                    this.successMessage.current.showMessage()
                } else if (data.error === 'password_not_pass_requirements') {
                    this.setState({
                        passwordNotPassRequirements: true,
                        password: '',
                    })
                } else if (data.error === 'already_logged_in') {
                    this.props.switchSignIn()
                } else {
                    this.setState({
                        errorMessage: this.arrayOfErrorMessage[data.error],
                        passwordNotPassRequirements: false,
                        password: '',
                    })
                    this.errorMessage.current.showMessage()
                }
            })
        }

    }

    checkValidInput = event => {
        let input = event.tagName === 'INPUT' ? event : event.target;
        input.setCustomValidity('');
        if (!input.validity.valid && input.type !== 'checkbox') {
            input.setCustomValidity(this.translation['fill this field']);
        } else if (!input.validity.valid && input.type === 'checkbox') {
            input.setCustomValidity(this.translation['check this box to continue']);
        }
    }

    inputFocus = event => {
        let elem = event.target,
            input = elem.tagName === 'INPUT' ?
                elem : elem.parentNode.querySelector('input');
        input.removeAttribute('readonly');
        input.classList.add('active');
        input.focus();
    }

    checkValueInputs = () => {
        let inputs = document.querySelectorAll('form input[type=text], form input[type=password]');
        inputs.forEach((item) => {
            if (item.value)
                item.classList.add('active');
            else
                item.classList.remove('active');
        })
    }

    removeAttrReadOnly = event => {
        let inputs = event.target.parentNode.querySelectorAll('input');
        inputs.forEach(item => {
            item.removeAttribute('readonly');
        })
    }

    render() {
        const { from } = this.props.location.state || {
            from: { pathname: '/' },
        }

        if (this.props.signIn) {
            return <Redirect to={from} />
        }

        return (
            <div className="regContainer">
                <h1 className="regContainer_header">{this.translation['Registration']}</h1>
                <hr />
                <div className="regContainer_main">
                    <form
                        className="regContainer_main_form"
                        onInvalid={this.checkValidInput}
                        onSubmit={this.sendFromRegistration}
                    >
                        <div className="regContainer_main_form_first-name">
                            <InputInitialForm
                                type="text"
                                name="firstname"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>{this.translation['First name']}</span>
                        </div>
                        <div className="regContainer_main_form_last-name">
                            <InputInitialForm
                                type="text"
                                name="lastname"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>{this.translation['Last name']}</span>
                        </div>
                        <div className="regContainer_main_form_email">
                            <InputInitialForm
                                type="text"
                                name="email"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>Email</span>
                        </div>
                        <div className="regContainer_main_form_password">
                            <InputInitialForm
                                type="password"
                                name="password"
                                title={this.translation['fill this field']}
                            />
                            <span onClick={this.inputFocus}>{this.translation['Password']}</span>
                            <p className={this.state.passwordNotPassRequirements ? '' : 'hidden'}>
                                {this.translation['Must be more']} {this.translation['than 6 symbols']}
                            </p>
                        </div>
                        <div className="regContainer_main_form_referral-code">
                            <input
                                name="code"
                                type="text"
                                ref={(ref) => this.codeInput = ref}
                                value={this.state.code}
                                onChange={e => {
                                    this.changeValue(e, 'code')
                                }}
                                autoComplete="off"
                                onFocus={this.inputFocus}
                                onBlur={this.checkValueInputs}
                                readOnly
                            />
                            <span onClick={this.inputFocus}>{this.translation['Referrer code']}</span>
                        </div>
                        {this.props.captchaKey ? (
                            <Recaptcha
                                sitekey={`${this.props.captchaKey}`}
                                ref={e => (this.recaptcha = e)}
                                render="explicit"
                                theme="dark"
                                size="normal"
                                badge="inline"
                                onloadCallback={this.recaptchaLoaded()}
                                hl={localStorage.language}
                            />
                        ) : null}
                        <div className="regContainer_main_form_checkbox">
                            <input
                                type="checkbox"
                                id="regCheckbox"
                                title={this.translation['check this box to continue']}
                                checked={this.state.checkbox}
                                onChange={e => {
                                    this.changeValue(e, 'checkbox')
                                }}
                                readOnly
                                required
                            />
                            <p>
                                {this.translation['I agree to the']} <a target="_blank" href="https://cryptaur.com/docs/Terms of User _Cryptaur.pdf?0129">{this.translation['terms and conditions']}</a>
                            </p>
                        </div>
                        <input
                            className="regContainer_main_form_register"
                            type="submit"
                            value={this.translation['Register']}
                            onClick={this.removeAttrReadOnly}
                        />
                    </form>
                </div>
                <ErrorMessage
                    ref={this.errorMessage}
                    errorMessage={this.state.errorMessage}
                />
                <SuccessMessage
                    ref={this.successMessage}
                    successMessage={this.state.successMessage}
                />
            </div>
        )
    }

    changeValue = (event, type) => {
        if (type === 'checkbox') {
            this.setState({
                [type]: event.target.checked,
            })
        } else {
            this.setState({
                [type]: event.target.value,
            })
        }
        this.checkValidInput(event);
    }

    recaptchaLoaded = () => {}
}
